/* eslint-disable react/prop-types */
import React from 'react';
import HorizontalScroll from '../../shared/HorizontalScroll';
import Spinner from '../../shared/spinner';
import NotesCard from '../../shared/NotesCard';

function NotesList({ data, loading }) {
  if (loading) {
    return <div><Spinner /></div>;
  }
  return (
    <div className="pt-[34px] lg:pt-[52px]">
      <HorizontalScroll className="gap-2">
        <NotesCard
          sectionTitle={data?.getListContents?.list?.name}
          page="notes"
          data={data?.getListContents}
          entityID={data?.getListContents?.list?.id}
          // filterShow={remoteConfigData.filter}
          wrapperClasses="flex gap-2 lg:grid-cols-3 gap-4"
        />
      </HorizontalScroll>
    </div>
  );
}

export default NotesList;
